import React from 'react';
import { Card, List, Tag, Alert, Empty, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

function SaludParqueItemTile({ data, loading }) {
  if (loading) return <Card title="Salud del parque — ítems" loading />;

  const topItems = data?.top_items_rechazados ?? [];
  const porCategoria = data?.por_categoria ?? [];

  if (topItems.length === 0 && porCategoria.length === 0) {
    return (
      <Card title="Salud del parque — ítems">
        <Empty description="Sin rechazos en los últimos 180 días" />
      </Card>
    );
  }

  const peorCategoria = [...porCategoria].sort(
    (a, b) => b.pct_rechazo - a.pct_rechazo,
  )[0];
  const top5 = topItems.slice(0, 5);

  return (
    <Card
      title={
        <span>
          Salud del parque — ítems{' '}
          <Tooltip title="Top ítems con más rechazos en los últimos 180 días">
            <InfoCircleOutlined style={{ color: '#8c8c8c' }} />
          </Tooltip>
        </span>
      }
    >
      {peorCategoria && peorCategoria.pct_rechazo >= 10 && (
        <Alert
          type="warning"
          showIcon
          message={`${peorCategoria.categoria}: ${peorCategoria.pct_rechazo}% de rechazo`}
          style={{ marginBottom: 12 }}
        />
      )}
      {top5.length > 0 ? (
        <List
          size="small"
          dataSource={top5}
          renderItem={(item) => (
            <List.Item style={{ padding: '6px 0' }}>
              <div style={{ flex: 1, minWidth: 0, marginRight: 8 }}>
                <div
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  title={item.titulo}
                >
                  {item.titulo}
                </div>
                {item.categoria && (
                  <Tag style={{ marginTop: 4 }}>{item.categoria}</Tag>
                )}
              </div>
              <Tag color="red">{item.rechazos}</Tag>
            </List.Item>
          )}
        />
      ) : (
        <Empty description="Sin ítems rechazados" />
      )}
    </Card>
  );
}

export default SaludParqueItemTile;
